module.exports = __webpack_public_path__ + "img/icon-pci.3bae881d.svg";